export const prepareAvailabilityData = (checkedState: any, acceptedJobDates?: Array<string>) => {
    const availabilities: any = {};

    // Iterate over each week in checkedState
    Object.keys(checkedState).forEach(weekKey => {
        // Skip non-week keys (like "token")
        if (!weekKey.startsWith("week_")) return;

        const weekData = checkedState[weekKey];
        Object.keys(weekData).forEach(day => {
            const dayData = weekData[day];
            if (dayData && dayData.date) {
                const formattedDate = changeDateFormat(dayData.date);

                if (!availabilities[formattedDate]) {
                    availabilities[formattedDate] = [];
                }
                availabilities[formattedDate].push({
                    day: day,
                    is_available: dayData.checked ? 1 : 0,
                    has_accepted_jobs: acceptedJobDates ? (acceptedJobDates?.includes(dayData.date) ? 1 : 0) : 0,
                });
            }
        });
    });

    return availabilities;
}

const changeDateFormat = (date: string) => {    
        // Parse "3 Jun 2025" as local date
        const [day, monthStr, year] = date.split(" ");
        const month = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ].indexOf(monthStr);
        // Pad day and month
        const dd = day.padStart(2, "0");
        const mm = String(month + 1).padStart(2, "0");
        return `${year}-${mm}-${dd}`;
    
}

export const filterByDay = (calendarData: any, dayToFilter: string) => {
    if(calendarData === null) return {};
    return Object.fromEntries(
      Object.entries(calendarData)
        .filter(([weekKey]) => weekKey !== "token")
        .map(([weekKey, weekData]) => [
          weekKey,
          (weekData as any)[dayToFilter] ? { [dayToFilter]: (weekData as any)[dayToFilter] } : {}
        ])
    );
  };